export default __webpack_public_path__ + "static/media/zoopraha-logo.ec39fdff.png";